<template>
<div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h4 dot-title mr-r10">모델링 방식</div>
      <div class="setting-addel">
        <el-button size="mini" @click="clickAddModelingButton"><i class="fas fa-plus"/></el-button>
        <el-button size="mini" @click="clickDeleteModelingButton" :disabled="checkedRows==0"><i class="fas fa-minus" /></el-button>
      </div>
    </div>
  </el-row>
  <el-table-wrapper v-loading="isLoading" :column-default="columnDefault" :data="modelingTableData" :columns="modelingTableColumns"
    ref="modelingTable" row-class-name="c-dblclick" @selection-change="changeCheckedRow" @row-dblclick="dblclickRow" highlight-current-row :pagination="false"
    style="width:100%;" :show-search-tool="false" :show-custom-header="true" @condition-change="changeTableCondition" remote :total="total">
  </el-table-wrapper>
  <w-add-modeling-popup ref="addModelingPopup" @re-load="loadData" :type="type" :selected-basic-info-form-data="selectedBasicInfoFormData" :selected-sub-form-data="selectedSubFormData" @close-popup="initSelectedInfo"></w-add-modeling-popup>
</div>
</template>

<script>
import { cloneDeep, isEqual, find, isEmpty } from 'lodash';

import msgUtil from '@/utils/message';

import DeviceRegistrationNmsAPI from '@/api/settings/common/device-registration-nms';
import { columnDefault } from '@/constants/table';
import WAddModelingPopup from '@/views/settings/basic/DeviceRegistration/Network/popup/AddModelingPopup';

export default {
  name: 'WModelingTable',
  components: {
    WAddModelingPopup,
  },
  props: {
    type: {
      type: String,
      default: 'setting',
    },
    checkedData: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      isLoading: false,
      columnDefault,
      showSearchTool: false,
      checkedRows: [],
      selectedBasicInfoFormData: null,
      selectedSubFormData: null,
      total: 0,
      modelingTableData: [],
      modelingTableColumns: [
        {
          type: 'selection',
          width: 45,
        },
        {
          prop: 'credentialName',
          label: '이름',
          headerAlign: 'center',
        },
        {
          prop: 'credentialMethodId',
          label: '방식',
          headerAlign: 'center',
        },
        {
          prop: 'credentialTypeId',
          label: '종류',
          headerAlign: 'center',
        },
        {
          prop: 'credentialDesc',
          label: '설명',
          headerAlign: 'center',
        },
      ],
      modelingCheckedTableColumns: [
        {
          prop: 'credentialName',
          label: '이름',
          headerAlign: 'center',

        },
        {
          prop: 'credentialDesc',
          label: '설명',
          headerAlign: 'center',
        },
      ],
    };
  },
  watch: {
    checkedRows(val) {
      if (!isEmpty(val)) {
        this.$emit('update:checkedData', val);
      }
      // this.$emit('update:checkedModeling', val);
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.modelingTable.getParameter();
      this.isLoading = true;
      DeviceRegistrationNmsAPI.getModelingMethodList(tableParams).then((response) => {
        this.modelingTableData = response.data.data;
        this.$nextTick(() => {
          if (this.checkedData.length > 0) {
            this.checkedData.forEach((checkedObject) => {
              this.modelingTableData.forEach((tableObject) => {
                if (isEqual(checkedObject.credentialId, tableObject.credentialId)) {
                  this.$refs.modelingTable.$children[0].toggleRowSelection(tableObject, true);
                }
              });
            });
          }
        });
      }).finally(() => {
        this.isLoading = false;
      });
    },
    init() {
      // this.modelingTableData = [];
      this.checkedRows = [];
      this.$refs.modelingTable.getTable().clearSelection();
    },
    setSelectionRow(checkedList) {
      checkedList.forEach((modeling) => {
        const findItem = find(this.modelingTableData, { credentialId: modeling.credentialId });
        this.$refs.modelingTable.getTable().toggleRowSelection(findItem);
      });
      this.checkedRows = checkedList;
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    clickAddModelingButton() {
      this.$refs.addModelingPopup.$refs.slidingPopup.visible = true;
    },
    clickDeleteModelingButton() {
      const target = '모델링 방식';
      const action = msgUtil.action.DELETE;

      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        DeviceRegistrationNmsAPI.deleteModelingMethodList(this.checkedRows).then((response) => {
          const result = response.data;
          if (result.success === true) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.checkedRows = [];
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        });
      });
    },
    dblclickRow(row) {
      DeviceRegistrationNmsAPI.getNmsCredentialValueList(row).then((response) => {
        this.selectedBasicInfoFormData = cloneDeep(row);
        this.selectedSubFormData = cloneDeep(response.data.data);
        this.$refs.addModelingPopup.$refs.slidingPopup.visible = true;
      });
    },
    changeCheckedRow(selection) {
      this.checkedRows = selection;
    },
    initSelectedInfo() {
      this.selectedBasicInfoFormData = null;
      this.selectedSubFormData = null;
    },
    changeTableCondition() {
      this.loadData();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/ScheduleSettings/NetworkScheduleSettings/components/table/ModelingTable.vue